// extracted by mini-css-extract-plugin
export default {"container":"default_container__1rnrl"};